import { useContext } from "react"
import { TabManagerContext } from "contexts/TabManager/TabManagerContext"

const useTabManager = () => {
  const { isActiveTab, isTabLocked, reloadPage } = useContext(TabManagerContext)
  return { isActiveTab, isTabLocked, reloadPage }
}

export default useTabManager
